/**
 * Labstep
 *
 * @module components/Entity/Table/SortOptions/Active
 * @desc Active sort options
 */

import { EntityTableSortOptionsOrder } from 'labstep-web/components/Entity/Table/SortOptions/Order';
import type { ISortOptions } from 'labstep-web/components/Entity/Table/SortOptions/types';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import { defaultSortOptionsCreatedAt } from '..';
import styles from './styles.module.scss';
import type { EntityTableSortOptionsActiveProps } from './types';

export const EntityTableSortOptionsActive: React.FC<
  EntityTableSortOptionsActiveProps
> = ({
  searchParams,
  clearParams,
  setParams,
  sortOptions,
  defaultSortOptions = defaultSortOptionsCreatedAt,
}) => {
  if (!searchParams.sort) {
    return null;
  }

  const options: ISortOptions = {
    ...defaultSortOptions,
    ...sortOptions,
  } as const;
  const activeSortKey = searchParams.sort as
    | `-${keyof ISortOptions}`
    | keyof ISortOptions;
  const activeSortOption =
    options[
      activeSortKey[0] === '-'
        ? (activeSortKey.slice(1) as keyof ISortOptions)
        : (activeSortKey as keyof ISortOptions)
    ];

  if (!activeSortOption) {
    return null;
  }

  return (
    <div data-testid="sort-active" className={styles.container}>
      <span>Sorting By:</span>
      <RemoveLabel
        name={activeSortOption.label}
        onRemoveClick={(): void => clearParams(['sort'])}
        action={
          <EntityTableSortOptionsOrder
            activeSortKey={activeSortKey}
            setParams={setParams}
          />
        }
      />
    </div>
  );
};
